import PolicyDoc from '@/components/PolicyDoc';
import { PRIVACY } from '@/shared/policy';

export const route = { path: '/privacy', layout: 'public', access: 'public' };

export default function Privacy() {
  return <PolicyDoc doc={PRIVACY} />;
}
